import { render, staticRenderFns } from "./MRTatDashboard.vue?vue&type=template&id=2397a6a6&scoped=true"
import script from "./MRTatDashboard.vue?vue&type=script&lang=js"
export * from "./MRTatDashboard.vue?vue&type=script&lang=js"
import style0 from "./MRTatDashboard.vue?vue&type=style&index=0&id=2397a6a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2397a6a6",
  null
  
)

export default component.exports